/**
 * Under a price field: the item's Stripe price, and that a new one is made by itself. Stripe prices
 * cannot change, so a new price gets a new id (the save queues it; checkout makes one if it is
 * still missing and never charges an old amount).
 */
export function stripePriceNote(item) {
  const id = item?.stripe_price_id;
  return id && String(id).startsWith("price_")
    ? `Stripe price ${id}. Change the price and a new Stripe price is made automatically.`
    : "No Stripe price yet: one is made automatically when the price changes or at the first checkout.";
}

/** Product prices can be changed by Admin and Super Admin only. */
export default function canChangeProductPrice() {
  const role = String(localStorage.getItem("role") || "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ");
  return role === "admin" || role === "super admin" || role === "super_admin";
}
